module.exports = __webpack_public_path__ + "img/xvg.29f106ba.svg";